import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/hooks/useAuth";

export const StickyMobileCTA = ({ heroRef }: { heroRef: React.RefObject<HTMLElement | null> }) => {
  const isMobile = useIsMobile();
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isMobile || !heroRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, [isMobile, heroRef]);

  if (!isMobile || !show) return null;

  return (
    <div className="fixed bottom-16 left-0 right-0 z-50 p-3 bg-background border-t border-border pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <Button asChild className="w-full gap-2" size="lg">
        <Link to={user ? "/dashboard" : "/auth"}>
          {user ? "Go to Dashboard" : "Get Started Free"} <ArrowRight className="h-4 w-4" />
        </Link>
      </Button>
    </div>
  );
};
